
import SortPicker from '../components/sort-picker.vue';
import EditRoom from './edit-room.vue';
export default {
    name: 'room',
    components: {
        SortPicker,
        EditRoom
    },
    created() {

        let t = this;

        t.editRoom(null);

        axios.get('room?_with=cleanAreas,tagMapping').then(res => {
            if (res.data.status == 1) {

                t.list.room = res.data.options.items;
                t.dict.room = listToDict(t.list.room);

                axios.get('group').then(res => {
                    if (res.data.status == 1) {
                        let arr = res.data.options.items;
                        arr.forEach(group => {
                            group.expanded = true;
                            group.rooms = [];
                            let roomIds = group.room_ids.split(',');
                            roomIds.forEach(roomId => {
                                if (t.dict.room[roomId]) {
                                    t.dict.room[roomId].selected = true;
                                    group.rooms.push(t.dict.room[roomId]);
                                }
                            });
                        });

                        t.list.group = arr;
                        t.openRoomFromQuery();

                        debug(() => {
                            // t.editRoom(t.list.room[0]);
                        });

                    }
                });


            }
        });

    },
    activated() {
        this.openRoomFromQuery();
    },
    watch: {
        '$route.query.room_id': function () {
            this.openRoomFromQuery();
        }
    },
    methods: {

        loadData() {

            let t = this;

            t.inited = false;

        },

        openRoomFromQuery() {
            let id = this.$route && this.$route.query && this.$route.query.room_id;
            if (!id || !this.dict.room[id]) return;
            this.editRoom(this.dict.room[id]);
        },

        isCurrentRoom(item) {
            return !!(item && this.room && item.id == this.room.id);
        },

        editRoom(room) {
            let t = this;
            let landlordId = t.assignLandlordId;
            if (room && landlordId && String(room.landlord_id || '') !== String(landlordId)) {
                if (t.assigning) return;
                t.assigning = true;
                axios.post('room/assignLandlord', {
                    room_id: room.id,
                    landlord_id: Number(landlordId)
                }).then(res => {
                    t.assigning = false;
                    if (!res.data || res.data.status != 1) {
                        if (window.A && A.toast) A.toast('追加に失敗しました');
                        return;
                    }
                    room.landlord_id = Number(landlordId);
                    let item = res.data.options && res.data.options.item;
                    if (item && item.landlord) room.landlord = item.landlord;
                    t.openEditor(room);
                    if (window.A && A.toast) A.toast('追加しました');
                }).catch(() => {
                    t.assigning = false;
                    if (window.A && A.toast) A.toast('通信に失敗しました');
                });
                return;
            }
            t.openEditor(room);
        },

        openEditor(room) {
            let t = this;
            t.room = room;
            t.showAddRoom = true;
            if (room)
                t.$nextTick(() => {
                    if (t.$refs.roomEditor) t.$refs.roomEditor.init();
                });
        },

        editor() {
            return this.$refs.roomEditor;
        },

        onEditSettlement() {
            if (this.editor()) this.editor().goRoomSettlement();
        },

        onAddAirhost() {
            if (this.editor()) this.editor().addFromAirhost();
        },

        onFocusLock() {
            if (this.editor()) this.editor().focusLock();
        }

    },
    data() {
        return {
            showAddRoom: false,
            assigning: false,
            showLockEditor: false,
            room: null,
            keywordSearch: {
                room_name: ''
            },
            list: {
                room: [],
                group: []
            },
            dict: {
                room: {}
            }
        };
    },
    computed: {
        assignLandlordId() {
            let id = this.$route && this.$route.query && this.$route.query.assign_landlord_id;
            return id ? String(id) : '';
        },
        filteredRooms() {
            let t = this;

            let arr = [];

            t.list.room.forEach(item => {
                if (t.keywordSearch.room_name && (item.name.indexOf(t.keywordSearch.room_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedRooms() {
            let t = this;

            let arr = [];

            t.list.room.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },
    }
};
